import { Amplify } from 'aws-amplify';
import { fetchAuthSession } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import { store } from "../redux/store";
import { signinSuccess, signoutSuccess } from '../redux/actions/auth'

export const configureAuth = () => {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: process.env.REACT_APP_COGNITO_POOL_ID,
        userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
      }
    }
  });

  Hub.listen('auth', async ({ payload }) => {
    switch (payload.event) {
      case 'signedIn':
        try {
          const session = await fetchAuthSession();
          store.dispatch(signinSuccess(session));
        } catch (e) {
          store.dispatch(signoutSuccess());
        }
        break;
      case 'signedOut':
        store.dispatch(signoutSuccess());
        break;
      default:
        break;
    }
  });
}
